import React from 'react'
import {DOP_LANGUAGES} from './dopLanguages'

type Props = {
    onSelect: (lang: string) => void
    buttonClassName?: string
}

const DopLanguageButtons = ({
                                onSelect,
                                buttonClassName = 'btn btn-sm btn-light-primary'
                            }: Props) => {

    return (

        <div className="d-flex align-items-center gap-2 flex-wrap">

            {DOP_LANGUAGES.map((lang) => (

                <button
                    key={lang.key}
                    type="button"
                    className={`${buttonClassName} d-flex align-items-center gap-2`}
                    onClick={() => onSelect(lang.key)}
                >
                    <span style={{fontSize: '18px'}}>
                        {lang.flag}
                    </span>

                    <span className="fw-semibold">
                        {lang.label}
                    </span>
                </button>

            ))}

        </div>
    )
}

export default DopLanguageButtons